<template>
  <div>
    <div>合同确认文字</div>
    <div>
      <Button type="info"
              @click="changeDisabled">确认签字</Button>
    </div>
    <div id="signature">
      <p>
        <em>签名区域</em>
      </p>
    </div>
    <div class="js-signature"
         @click="changeDisabled"
         data-width="400"
         data-height="200"
         data-border="1px solid #cdcdcd"
         data-line-color="#bc0000"
         data-line-width="4"
         data-auto-fit="true"></div>
    <p>
      <button id="clearBtn"
              class="btn btn-default"
              @click="clearCanvas();">重写</button>
      <button id="saveBtn"
              class="btn btn-default"
              @click="saveSignature();"
              disabled>确认签约</button>
    </p>
  </div>
</template>
<script>
import $ from 'jquery'
import '../../public/js/jq-signature.js';
export default {
  data () {
    return {

    }
  },
  mounted () {
    $('.js-signature').jqSignature();
  },
  methods: {
    clearCanvas () {
      $('#signature').html('<p><em>点击确认签名保存</em></p>');
      $('.js-signature').eq(0).jqSignature('clearCanvas');
      $('#saveBtn').attr('disabled', true);
    },
    saveSignature () {
      $('#signature').empty();
      var dataUrl = $('.js-signature').eq(0).jqSignature('getDataURL');
      var img = $('<img>').attr('src', dataUrl);
      // console.log(dataUrl);

      $('#signature').append($('<p>').text("你的签名:"));
      $('#signature').append(img);

      var imgs = dataUrl;

      imgs = imgs.replace(/\&/g, "%26");
      imgs = imgs.replace(/\+/g, "%2B");

      $.ajax({
        url: "<?php echo base_url();?>sign/save/",
        type: "post",
        data: { 'sign': imgs },
        dataType: "json",
        success: function (data) {
          if (data.error == 1) {
            alert(data.msg);
          }
          if (data.error == 0) {
            alert("成功签约！");
            window.location.href = "<?php echo base_url()?>sign/";
          }

        },
        error: function () {
          alert("您的网络不稳定,请刷新重试！");
        }
      });
    },
    changeDisabled () {
      // $('.js-signature').trigger('jq.signature.changed');
      // $('.js-signature').eq(0).on('jq.signature.changed', function() {
      $('#saveBtn').attr('disabled', false);
      // });
    }
  }
}
</script>
<style lang="less" scoped>
</style>
